<template>
	<multiselect :placeholder="placeholderFinalMsg" v-bind="$props" v-on="$listeners">
		<template v-slot:noOptions>{{noOptionsFinalMsg}}</template>
		<template v-slot:noResult>{{noResultFinalMsg}}</template>
		<template v-slot:maxOptions>{{maxOptionsFinalMsg}}</template>
		<template v-slot:placeholder>{{placeholderFinalMsg}}</template>
	</multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
	extends: Multiselect,
	props: {
		selectLabel: { default: "Tecle enter para selecionar" },
		selectGroupLabel: { default: "Tecle enter para selecionar grupo" },
		selectedLabel: { default: "Selecionado" },
		deselectLabel: { default: "Tecle enter para remover" },
		deselectGroupLabel: { default: "Tecle enter para deselecionar grupo" },
		placeholder: { default: "Selecione uma <option>" },
		tagPlaceholder: {default: "Tecle enter para criar tag" },
		noOptions: { default: "Não há <option> para selecionar" },
		noResult: { default: "Nenhum <option> foi encontrado" },
		maxOptions: { default: "Não é permitido selecionar mais do que <max> <option>." },
		optionName: { default: "opção" },
		optionsName: { default: "opções" },
	},
	data() {
		return {
			maxOptionsFinalMsg: this.replaceVariables(this.maxOptions, this.optionsName),
			noResultFinalMsg: this.replaceVariables(this.noResult, this.optionName),
			noOptionsFinalMsg: this.replaceVariables(this.noOptions, this.optionName),
			placeholderFinalMsg: this.replaceVariables(this.placeholder, this.optionName),
		};
	},
	methods: {
		replaceVariables(message) {
			return message.replace(/<option>/, this.optionName)
				.replace(/<options>/, this.optionsName)
				.replace(/<max>/, this.maxOptions);
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/BlumarMultiSelect.vue